import CONFIG from '../config/config';
import { CustomerStatus } from '../shared/customerStatusToTranslationKey';
import { INBOUND_CHANNEL } from '../shared/inboundChannelToTranslationKey';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';
import { Sale } from './SalesAPI';
import { serializeParamsForSpringBoot } from './serializeParamsForSpringBoot';

export type CustomerResponse = {
  customer: Customer,
};

export type CustomerMeetingEnriched = {
  meeting: any;
  paymentInfo?: {
    paymentStatus?: string;
    paymentAmount?: number;
    paymentCurrency?: string;
  };
  bookingTrackingUrl?: string;
}

export type Customer = {
  id?: string;
  name: string;
  surname: string;
  countryCode?: string;
  phone?: string;
  email?: string;
  status: CustomerStatus;
  employeeId?: string;
  attachments: string[];
  notes?: string;
  flagged?: boolean;
  weddingDate?: string;
  inboundChannel?: INBOUND_CHANNEL;
  orders?: any[];
  meetings?: any[];
  enrichedMeetings?: CustomerMeetingEnriched[];
  sales?: Sale[];
}

type BodyApiResponse = Customer[];

type PaginatedResponse = {
  content: Customer[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
};

export type CustomerSortBy = 'weddingDate' | 'nextAppointmentDate';
export type CustomerSortDirection = 'ASC' | 'DESC';

type CustomerFilters = {
  employee?: string;
  employeeIds?: string[];
  page?: number;
  size?: number;
  status?: string;
  statuses?: CustomerStatus[];
  weddingMonth?: string;
  sortBy?: CustomerSortBy;
  sortDirection?: CustomerSortDirection;
};

const CustomersAPI = {
  get: ({ employee, employeeIds, page = 0, size = 50, status, statuses, weddingMonth, sortBy, sortDirection }: CustomerFilters) => {
    const params: Record<string, unknown> = {};
    if (employeeIds && employeeIds.length > 0) params.employeeIds = employeeIds;
    else if (employee) params.employee = employee;
    if (statuses && statuses.length > 0) params.statuses = statuses;
    else if (status) params.status = status;
    if (weddingMonth) params.weddingMonth = weddingMonth;
    if (sortBy) params.sortBy = sortBy;
    if (sortDirection) params.sortDirection = sortDirection;
    params.page = page;
    params.size = size;
    return APIClient(CONFIG.API_ENDPOINT).get<PaginatedResponse>(`v1/customersCrm`, {
      params,
      paramsSerializer: serializeParamsForSpringBoot,
    })
  },
  getById: (id: string) => APIClient(CONFIG.API_ENDPOINT).get<Customer>(`/v1/customersCrm/${id}`),
  search: (text: string) => APIClient(CONFIG.API_ENDPOINT).get<PaginatedResponse>(`v1/customersCrm?searchText=${text}&page=0&size=50`),
  add: (customer: Customer) => APIClient(CONFIG.API_ENDPOINT).post<Customer>(`/v1/customersCrm`, customer),
  update: (id: string, customer: Customer) => APIClient(CONFIG.API_ENDPOINT).put<Customer>(`/v1/customersCrm/${id}`, customer),
  remove: (id: string) => APIClient(CONFIG.API_ENDPOINT).delete<BodyApiResponse>(`/v1/customersCrm/${id}`),
};

export default CustomersAPI;
